module.exports = __webpack_public_path__ + "d0402a5f99b784059a40fae8ec8df9ff.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/walibi-holland-webfont.woff
// module id = 31
// module chunks = 0